(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class GlowmingHeader extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.nav');
      this.drawer = this.querySelector('.nav-drawer');
      this.overlay = this.querySelector('[data-nav-overlay]');
      this.toggle = this.querySelector('[data-nav-toggle]');
      // Every reference is scoped to this element and every use is guarded. The
      // 2025 theme.js reached out to eight document-level IDs unguarded, so one
      // missing element killed the whole file.
      if (!this.nav || !this.drawer || !this.overlay || !this.toggle) return;

      // Threshold and initialisation match the 2025 theme.js EXACTLY: > 10, and
      // no call on load. `scrolled` applies a box-shadow, so a different
      // threshold or an extra initial call is a visible pixel difference at the
      // top of every page. D1 - preserve exactly.
      this.onScroll = () => this.nav.classList.toggle('scrolled', window.scrollY > 10);
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen()));
      this.overlay.addEventListener('click', () => this.setOpen(false));
      this.querySelector('[data-nav-close]')?.addEventListener('click', () => this.setOpen(false));
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.setOpen(false); });

      this.querySelector('[data-nav-back]')?.addEventListener('click', () => {
        const sameHost = document.referrer && document.referrer.indexOf(window.location.host) !== -1;
        if (sameHost) history.back(); else window.location.href = window.Shopify?.routes?.root || '/';
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    isOpen() { return this.drawer.classList.contains('open'); }

    setOpen(open) {
      this.drawer.classList.toggle('open', open);
      this.overlay.classList.toggle('open', open);
      this.toggle.classList.toggle('open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
    }
  }
  if (!customElements.get('glowming-header')) {
    customElements.define('glowming-header', GlowmingHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
